export function createTravelStore() {
  return {
    user: window._bootstrap_data,
    suggestion: null,
    successfullyDeletedUser: null,
    successfullyLoggedOut: null,
  };
}
